import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, Inject, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { BaseDto } from '@models/base/baseDto.model';
import { AccionesDialog, EstadosRegistroContable, Paises, TiposMoneda } from '@models/base/identificadores.model';
import { ExpedienteSummaryDto } from '@models/expediente/expedienteSummary.model';
import { LoginService } from '@services/login/login.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { ButtonAddComponent } from 'src/app/component/button-add/button-add.component';
import { ButtonCancelDialogComponent } from 'src/app/component/button-cancel-dialog/button-cancel-dialog.component';
import { ButtonCloseDialogComponent } from 'src/app/component/button-close-dialog/button-close-dialog.component';
import { ButtonCloseComponent } from 'src/app/component/button-close/button-close.component';
import { ButtonDeleteAndCancelComponent } from 'src/app/component/button-delete-and-cancel/button-delete-and-cancel.component';
import { ButtonDeleteComponent } from 'src/app/component/button-delete/button-delete.component';
import { ButtonSaveComponent } from 'src/app/component/button-save/button-save.component';
import { BuscarExpedienteComponent } from '@views/busquedas/buscar-expediente/buscar-expediente.component';
import { RegistroContableDto } from '@models/registroContable/registroContableDto.model';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { EmpresaUsuarioService } from '@services/empresaUsuario/empresaUsuario.service';
import { EmpresaUsuarioDto } from '@models/empresaUsuario/empresaUsuarioDto.model';
import { BuscarLocalidadComponent } from '@views/busquedas/buscar-localidad/buscar-localidad.component';
import { BuscarProvinciaGeorefComponent } from '@views/busquedas/buscar-provincia-georef/buscar-provincia-georef.component';
import { BuscarLocalidadGeorefComponent } from '@views/busquedas/buscar-localidad-georef/buscar-localidad-georef.component';
import { BuscarProvinciaLocalidadGeorefComponent } from '@views/busquedas/buscar-provincia-localidad-georef/buscar-provincia-localidad-georef.component';
import { LocalidadBasicDto } from '@models/localidad/localidadBasicDto.model';
import { RegistroContableService } from '@services/registroContable/registroContable.service';
import { TipoRegistroContableService } from '@services/tipoRegistroContable/tipoRegistroContable.service';
import { CreateRegistroContableRequest } from '@models/registroContable/createRegistroContableRequest.model';
import { UpdateRegistroContableRequest } from '@models/registroContable/updateRegistroContableRequest.model';
import { isFalsy } from 'utility-types';
import { EstadoRegistroContableService } from '@services/estadoRegistroContable/estadoRegistroContable.service';
import { CuentaContableService } from '@services/cuentaContable/cuentaContable.service';
import { CuentaCajaService } from '@services/cuentaCaja/cuentaCaja.service';
import { DtoBase } from '@models/base/dtoBase.model';
import { CuentaCajaDto } from '@models/cuentaCaja/cuentaCajaDto.model';
import { CuentaContableDto } from '@models/cuentaContable/cuentaContableDto.model';
import { TipoMonedaService } from '@services/tipoMoneda/tipoMoneda.service';
import { MatChipEditedEvent, MatChipInputEvent, MatChipsModule } from '@angular/material/chips';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MonedaDirective } from '@directives/moneda.directive';
import { SelectUsuariosEmpresaComponent } from 'src/app/component/select-usuarios-empresa/select-usuarios-empresa.component';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

@Component({
  selector: 'app-dialog-form-registroContable',
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatDialogModule, ButtonCloseDialogComponent, A11yModule, CommonModule, MatExpansionModule, ButtonSaveComponent, MatCardModule, MatIconModule, MatButtonModule, MatDividerModule, NgxSpinnerModule, MatTableModule, MatSliderModule, MatSlideToggleModule, MatMenuModule, MatDatepickerModule, MatRadioModule, MatSelectModule, FormsModule, MatSortModule, MatTooltipModule, MatPaginatorModule, MatRippleModule, MatNativeDateModule, BuscarExpedienteComponent, MatTabsModule, ButtonCancelDialogComponent, ButtonAddComponent, MatCheckboxModule, ButtonDeleteComponent, MatAutocompleteModule, MatChipsModule, MatTabsModule, SelectUsuariosEmpresaComponent, NgxMaskDirective],
  templateUrl: './dialog-form-registro-contable.component.html',
  styleUrl: './dialog-form-registro-contable.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [provideNgxMask()]
})


export class DialogFormRegistroContableComponent {
  estadosregistroContable!: BaseDto[];
  expedienteDto!: ExpedienteSummaryDto;
  paises!: BaseDto[];
  empresaUsuarioDto!: EmpresaUsuarioDto;
  registroContable: any;
  tiposRegistroContable!: BaseDto[];
  registroContableDto!: RegistroContableDto;
  tiposMoneda!: BaseDto[];
  get f() { return this.form.controls; }
  accionesDialog = AccionesDialog;
  form!: FormGroup;
  localData: any;
  formBuilder: FormBuilder = new FormBuilder;
  estadosRegistroContable!: DtoBase[];
  cuentasContables!: CuentaContableDto[];
  cuentasCaja!: CuentaCajaDto[];
  etiquetas = [''];

  constructor(
    public dialogRef: MatDialogRef<DialogFormRegistroContableComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private registroContableService: RegistroContableService,
    private tipoRegistroContableService: TipoRegistroContableService,
    private empresaUsuarioService: EmpresaUsuarioService,
    private router: Router,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private loginService: LoginService,
    private estadoRegistroContableService: EstadoRegistroContableService,
    private cuentaContableService: CuentaContableService,
    private cuentaCajaService: CuentaCajaService,
    private tipoMonedaService: TipoMonedaService,

  ) {

    this.getAllTiposRegistroContable()
    this.getAllCuentaCaja()
    this.getAllCuentaContable()
    this.getAllEstadosRegistroContable()
    this.getAllTiposMoneda();
  }

  ngOnInit(): void {


    this.registroContable = this.data?.RegistroContable || {};

    if (this.data?.RegistroContable?.id)
      this.getById(this.data?.RegistroContable.id)
    else
    this.setForm();

  }

 setForm(): void {
    this.form = this.formBuilder.group({
      Id: [this.registroContable?.id || null],
      Descripcion: [this.registroContable?.descripcion || '', Validators.compose([Validators.maxLength(200)])],
      EgresoIngreso: ['-1', Validators.compose([Validators.required])],
      Observaciones: [this.registroContable?.observaciones || '', Validators.compose([Validators.maxLength(500)])],
      Importe: [Math.abs(this.registroContable?.importe ?? 0), Validators.compose([Validators.min(0), Validators.required])],
      Fecha: [this.registroContable?.fecha || new Date, Validators.compose([Validators.required])],
      AprobadoPor: [this.registroContable?.aprobadoPor?.id || null],
      CotizacionMonedaOrigen: [this.registroContable?.cotizacionMonedaOrigen || null],
      ImporteMonedaOrigen: [this.registroContable?.importeMonedaOrigen || null],
      IdCuentaContable: [this.registroContable?.idCuentaContable || null],
      IdAsientoContable: [this.registroContable?.idAsientoContable || null],
      IdArchivo: [this.registroContable?.idArchivo || null],
      ReferenciaExterna: [this.registroContable?.referenciaExterna || '', Validators.compose([Validators.maxLength(200)])],
      Etiqueta: [this.registroContable?.etiqueta || '', Validators.compose([Validators.maxLength(100)])],
      IdRegistroRelacionado: [this.registroContable?.idRegistroRelacionado || null],
      Origen: [this.registroContable?.origen || '', Validators.compose([Validators.maxLength(100)])],
      IdComprobante: [this.registroContable?.idComprobante || null],
      EsEditable: [this.registroContable?.esEditable !== undefined ? this.registroContable?.EsEditable : true],
      FechaAprobacion: [this.registroContable?.fechaAprobacion || null],
      IdEstadoRegistroContable: [this.registroContable?.estadoRegistroContable?.id || EstadosRegistroContable.Pendiente],
      IdTipoRegistroContable: [this.registroContable?.tipoRegistroContable?.id || null, Validators.compose([Validators.required])],
      IdPlanillaCaja: [this.registroContable?.planillaCaja?.id || null],
      IdCuentaCaja: [this.registroContable?.cuentaCaja?.id || null],
      IdTipoMonedaLocal: [this.registroContable?.tipoMonedaLocal?.id || TiposMoneda.PesoArgentino, Validators.compose([Validators.required])],
      IdTipoMonedaOrigen: [this.registroContable?.tipoMonedaOrigen?.id || TiposMoneda.PesoArgentino],
      IdExpediente: [this.registroContable?.expediente?.id || null],
    });

    this.form.get('ImporteMonedaOrigen')?.valueChanges.subscribe(() => this.actualizarImporte());
    this.form.get('CotizacionMonedaOrigen')?.valueChanges.subscribe(() => this.actualizarImporte());
    this.form.get('Importe')?.updateValueAndValidity();
  }

  removerEtiqueta(etiqueta: string) {
    const index = this.etiquetas.indexOf(etiqueta);
    if (index >= 0) {
      this.etiquetas.splice(index, 1);
    }
  }

  agregarEtiqueta(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value) {
      this.etiquetas.push(value);
    }
    event.chipInput!.clear();
  }

  onUsuarioSeleccionado(usuario: any) {
    this.form.get('AprobadoPor')?.setValue(usuario.id);
  }

  readonly separatorKeysCodes = [ENTER, COMMA] as const;


  editarEtiqueta(fruit: string, event: MatChipEditedEvent) {
    const value = event.value.trim();

    if (!value) {
      this.removerEtiqueta(fruit);
      return;
    }
    const index = this.etiquetas.indexOf(fruit);
    if (index >= 0) {
      this.etiquetas[index] = value;
    }
  }

  getAllTiposRegistroContable() {
    this.spinner.show("spTipoRegistroContable")
    this.tipoRegistroContableService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spTipoRegistroContable")
          this.tiposRegistroContable = data
        },
        error => {
          this.spinner.hide("spTipoRegistroContable")
          this.snackBar.showError(error, "Error");
        })
  }

  getAllEstadosRegistroContable() {
    this.spinner.show('spEstadosRegistroContable')
    this.estadoRegistroContableService.getAll()
      .subscribe(
        data => {
          this.spinner.hide('spEstadosRegistroContable')
          this.estadosRegistroContable = data
          if (!this.registroContable.estadoRegistroContable) {
            this.form.get('IdTipoMonedaOrigen')?.setValue(TiposMoneda.PesoArgentino);
          }
        },
        error => {
          this.spinner.hide('spEstadosRegistroContable')
          this.snackBar.showError(error, "Error");
        })
  }

  getAllTiposMoneda() {
    this.spinner.show('spTiposMoneda')
    this.tipoMonedaService.getAll()
      .subscribe(
        data => {
          this.spinner.hide('spTiposMoneda')
          this.tiposMoneda = data
        },
        error => {
          this.spinner.hide('spTiposMoneda')
          this.snackBar.showError(error, "Error");
        })
  }

  getAllCuentaContable() {
    this.spinner.show('spCuentaContable')
    this.cuentaContableService.getAll()
      .subscribe(
        data => {
          this.spinner.hide('spCuentaContable')
          this.cuentasContables = data
        },
        error => {
          this.spinner.hide('spCuentaContable')
          this.snackBar.showError(error, "Error");
        })
  }

  getById(id: number) {
    this.spinner.show('spRegistroContable')
    this.registroContableService.getById(id)
      .subscribe(
        data => {
          this.spinner.hide('spRegistroContable')
          this.registroContable = data
          this.setForm();
        },
        error => {
          this.spinner.hide('spRegistroContable')
          this.snackBar.showError(error, "Error");
        })
  }

  getAllCuentaCaja() {
    this.spinner.show('spCuentaCaja')
    this.cuentaCajaService.getAll()
      .subscribe(
        data => {
          this.spinner.hide('spCuentaCaja')
          this.cuentasCaja = data
        },
        error => {
          this.spinner.hide('spCuentaCaja')
          this.snackBar.showError(error, "Error");
        })
  }


  onLocalidadSeleccionada(localidad: any): void {
    this.registroContable.idLocalidad = localidad.id;
    this.form.get('IdLocalidad')?.setValue(this.registroContable.idLocalidad);
  }

  actualizarImporte(): void {
    const importeOrigen = this.form.get('ImporteMonedaOrigen')?.value || 0;
    const cotizacion = this.form.get('CotizacionMonedaOrigen')?.value || 0;
    const importeCalculado = importeOrigen * cotizacion;
    this.form.get('Importe')?.setValue(importeCalculado, { emitEvent: true });
    this.form.get('Importe')?.updateValueAndValidity();
  }

  getAllUsuarioByIdEmpresa() {
    this.spinner.show('spPaises')
    this.empresaUsuarioService.getAll()
      .subscribe(
        data => {
          this.spinner.hide('spPaises')
          const empresaUsuarioDtoEncontrado = data.find(x => x.usuario.id === this.loginService.getIdUser());
          if (empresaUsuarioDtoEncontrado) {
            this.empresaUsuarioDto = empresaUsuarioDtoEncontrado;
            //this.form.get('IdPais')?.setValue(this.empresaUsuarioDto.empresa.pais.id);
          }

        },
        error => {
          this.spinner.hide('spPaises')
          this.snackBar.showError(error, "Error");
        })
  }

  selectExpediente($event: any) {
    this.expedienteDto = $event
    this.form.controls['IdExpediente'].setValue(this.expedienteDto.id)
  }

  cancelar() {
    this.dialogRef.close({ event: AccionesDialog.Cancelar, data: this.data });
  }



  agregar() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.spinner.show("spRegistroContable")
    this.registroContableService.create(this.setCreateRegistroContableRequest())
      .subscribe(
        data => {
          this.spinner.hide("spRegistroContable")
          this.snackBar.showSuccess('Registro creado con correctamente.', "Exito");
          this.dialogRef.close({ event: AccionesDialog.Agregar, data: this.data.registroContable, expediente: this.expedienteDto });
        },
        error => {
          this.spinner.hide("spRegistroContable")
          this.snackBar.showError(error, "Error");
          this.dialogRef.close({ event: AccionesDialog.Cancelar, data: null });
        })
  }

  modificar() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.spinner.show("spRegistroContable")
    this.registroContableService.update(this.setUpdateRegistroContableRequest())
      .subscribe(
        data => {
          this.spinner.hide("spRegistroContable")
          this.snackBar.showSuccess('Registro modificado correctamente.', "Exito");
          this.dialogRef.close({ event: AccionesDialog.Modificar, data: this.data.registroContable, expediente: this.expedienteDto });
        },
        error => {
          this.spinner.hide("spRegistroContable")
          this.snackBar.showError(error, "Error");
          this.dialogRef.close({ event: AccionesDialog.Cancelar, data: null });
        })
  }

  eliminar() {
    this.spinner.show("spRegistroContable")
    this.registroContableService.delete(this.data.registroContable.id)
      .subscribe(
        data => {
          this.spinner.hide("spRegistroContable")
          this.snackBar.showSuccess('Registro eliminado correctamente.', "Exito");
          this.dialogRef.close({ event: AccionesDialog.Eliminar, data: this.data.registroContable, expediente: this.expedienteDto });
        },
        error => {
          this.spinner.hide("spRegistroContable")
          this.snackBar.showError(error, "Error");
          this.dialogRef.close({ event: AccionesDialog.Cancelar, data: null });
        })
  }

  setCreateRegistroContableRequest(): CreateRegistroContableRequest {
    const request = new CreateRegistroContableRequest();

    request.descripcion = this.form.controls['Descripcion'].value || null;
    request.observaciones = this.form.controls['Observaciones'].value || null;
    request.fecha = this.form.controls['Fecha'].value || null;
    request.aprobadoPor = this.form.controls['AprobadoPor'].value || null;
    request.cotizacionMonedaOrigen = this.form.controls['CotizacionMonedaOrigen'].value || 0;
    request.importeMonedaOrigen = this.form.controls['ImporteMonedaOrigen'].value || 0;
    request.idCuentaContable = this.form.controls['IdCuentaContable'].value || null;
    request.idAsientoContable = this.form.controls['IdAsientoContable'].value || null;
    request.idArchivo = this.form.controls['IdArchivo'].value || null;
    request.referenciaExterna = this.form.controls['ReferenciaExterna'].value || null;
    request.etiqueta = this.form.controls['Etiqueta'].value || null;
    request.idRegistroRelacionado = this.form.controls['IdRegistroRelacionado'].value || null;
    request.origen = this.form.controls['Origen'].value || null;
    request.idComprobante = this.form.controls['IdComprobante'].value || null;
    request.esEditable = this.form.controls['EsEditable'].value === false ? false : true;
    request.fechaAprobacion = this.form.controls['FechaAprobacion'].value || null;
    request.idEstadoRegistroContable = this.form.controls['IdEstadoRegistroContable'].value || null;
    request.idTipoRegistroContable = this.form.controls['IdTipoRegistroContable'].value || null;
    request.idPlanillaCaja = this.form.controls['IdPlanillaCaja'].value || null;
    request.idCuentaCaja = this.form.controls['IdCuentaCaja'].value || null;
    request.idTipoMonedaLocal = this.form.controls['IdTipoMonedaLocal'].value || null;
    request.idTipoMonedaOrigen = this.form.controls['IdTipoMonedaOrigen'].value || null;
    request.idExpediente = this.form.controls['IdExpediente'].value || null;

    let signo = isFalsy(this.form.controls['EgresoIngreso'].value) ? 0 : parseInt(this.form.controls['EgresoIngreso'].value);
    request.importe = isFalsy(this.form.controls['Importe'].value) ? 0 : this.form.controls['Importe'].value * signo;

    return request;
  }


  setUpdateRegistroContableRequest(): UpdateRegistroContableRequest {
    const request = new UpdateRegistroContableRequest();

    request.id = this.form.controls['Id'].value;
    request.descripcion = this.form.controls['Descripcion'].value || null;
    request.observaciones = this.form.controls['Observaciones'].value || null;
    request.importe = this.form.controls['Importe'].value || 0;
    request.fecha = this.form.controls['Fecha'].value || null;
    request.aprobadoPor = this.form.controls['AprobadoPor'].value || null;
    request.cotizacionMonedaOrigen = this.form.controls['CotizacionMonedaOrigen'].value || 0;
    request.importeMonedaOrigen = this.form.controls['ImporteMonedaOrigen'].value || 0;
    request.idCuentaContable = this.form.controls['IdCuentaContable'].value || null;
    request.idAsientoContable = this.form.controls['IdAsientoContable'].value || null;
    request.idArchivo = this.form.controls['IdArchivo'].value || null;
    request.referenciaExterna = this.form.controls['ReferenciaExterna'].value || null;
    request.etiqueta = this.form.controls['Etiqueta'].value || null;
    request.idRegistroRelacionado = this.form.controls['IdRegistroRelacionado'].value || null;
    request.origen = this.form.controls['Origen'].value || null;
    request.idComprobante = this.form.controls['IdComprobante'].value || null;
    request.esEditable = this.form.controls['EsEditable'].value === false ? false : true;
    request.fechaAprobacion = this.form.controls['FechaAprobacion'].value || null;
    request.idEstadoRegistroContable = this.form.controls['IdEstadoRegistroContable'].value || null;
    request.idTipoRegistroContable = this.form.controls['IdTipoRegistroContable'].value || null;
    request.idPlanillaCaja = this.form.controls['IdPlanillaCaja'].value || null;
    request.idCuentaCaja = this.form.controls['IdCuentaCaja'].value || null;
    request.idTipoMonedaLocal = this.form.controls['IdTipoMonedaLocal'].value || null;
    request.idTipoMonedaOrigen = this.form.controls['IdTipoMonedaOrigen'].value || null;
    request.idExpediente = this.form.controls['IdExpediente'].value || null;
    let signo = isFalsy(this.form.controls['EgresoIngreso'].value) ? 0 : parseInt(this.form.controls['EgresoIngreso'].value);
    request.importe = isFalsy(this.form.controls['Importe'].value) ? 0 : this.form.controls['Importe'].value * signo;

    return request;
  }


  onReset() {
    this.form.reset();
  }

  trackByregistroContables(index: number, registroContable: any): any { return registroContable; }



  async getRegistroContableById(id: number) {
    this.spinner.show("spView")
    await this.registroContableService.getById(id)
      .subscribe(
        data => {
          this.spinner.hide("spView")
          this.registroContableDto = data
          this.setForm();
        },
        error => {
          this.spinner.hide("spView")
          this.snackBar.showError(error, "Error");
        })
  }

  esUrlValida(url: string): boolean {
    try {
      new URL(url);
      return true;
    } catch (_) {
      return false;
    }
  }

  abrirUrl(url: string): void {
    if (this.esUrlValida(url)) {
      window.open(url, '_blank');
    }
  }
}

